import React from "react";
import "./Title.scss";

export default function Title() {
  return (
    <div className="title">
      <h2>Hello, I am</h2>
      <h1>Nikita Temniy</h1>
      <span>Web-developer</span>
    </div>
  );
}
